"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function PDFViewer({ url, height = '500px', width = '100%', }) {
    const [fileURL] = (0, react_1.useState)(url);
    return ((0, jsx_runtime_1.jsx)("div", { className: "field-attachments-pdf-viewer", children: (0, jsx_runtime_1.jsx)("embed", { src: fileURL, type: "application/pdf", height: height, width: width }) }));
}
exports.default = PDFViewer;
